import React, { useContext } from 'react'
import { AuthenticationContext } from '../Auth/authentication.context'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

const ManufacturersPrivate = () => {
  const { user } = useContext(AuthenticationContext)
  const location = useLocation()

  // If not logged in, redirect to manufacturer login with return URL
  if (!user) {
    return <Navigate to={`/manufacturer-login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />
  }

  // If logged in but not a manufacturer, show 403
  if (user.role !== 'manufacturer') {
    return <Navigate to='/403' />
  }

  return <Outlet />
}

export default ManufacturersPrivate
